import React, { useState, useEffect } from 'react';
import { Button, Spinner, Alert } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

import Constants from '../Constants';
import { useAuth } from '../AuthContext';
import SalesProfileFormFields from '../components/SalesProfileFormFields';
import '../App.css';

const EMPTY_FORM = { name: '', solution_category: '', offering_description: '' };

function SalesProfileView() {
	const { token } = useAuth();
	const navigate = useNavigate();
	const { id } = useParams();
	const is_new = id === 'new';

	const [form, set_form] = useState(EMPTY_FORM);
	const [loading, set_loading] = useState(false);
	const [saving, set_saving] = useState(false);
	const [error, set_error] = useState('');

	useEffect(() => {
		if(is_new) return;
		const fetch_profile = async () => {
			set_loading(true);
			set_error('');
			try {
				const headers = token ? { Authorization: 'Bearer ' + token } : {};
				const response = await axios.get(
					Constants.SERVER_URL + '/api/sales_profiles/' + id,
					{ headers }
				);
				const p = response.data.profile;
				set_form({ name: p.name, solution_category: p.solution_category, offering_description: p.offering_description });
			} catch (err) {
				set_error('Failed to load profile.');
			} finally {
				set_loading(false);
			}
		};
		fetch_profile();
	}, [id, token]);

	const handle_change = (field, value) => {
		set_form(prev => Object.assign({}, prev, { [field]: value }));
	};

	const handle_save = async () => {
		set_saving(true);
		set_error('');
		try {
			const headers = token ? { Authorization: 'Bearer ' + token } : {};
			const payload = Object.assign({}, form);
			if(is_new) {
				await axios.post(Constants.SERVER_URL + '/api/sales_profiles', payload, { headers });
			} else {
				await axios.put(Constants.SERVER_URL + '/api/sales_profiles/' + id, payload, { headers });
			}
			navigate('/sales-profiles');
		} catch (err) {
			set_error('Failed to save profile.');
		} finally {
			set_saving(false);
		}
	};

	const can_save = form.name.trim().length > 0
		&& form.solution_category.trim().length > 0
		&& form.offering_description.trim().length > 0;

	return (
		<main className="sp-editor-main">
			<div className="sp-editor-header">
				<h4 className="sp-editor-title">{is_new ? 'New Sales Profile' : 'Edit Sales Profile'}</h4>
			</div>
			{error ? <Alert variant="danger">{error}</Alert> : null}
			{loading ? (
				<div className="sp-profiles-loading"><Spinner animation="border" size="sm" /></div>
			) : (
				<React.Fragment>
					<SalesProfileFormFields form={form} on_change={handle_change} />
					<div className="sp-editor-footer">
						<Button variant="outline-secondary" onClick={() => navigate('/sales-profiles')} disabled={saving}>
							Cancel
						</Button>
						<Button variant="primary" onClick={handle_save} disabled={!can_save || saving}>
							{saving ? <Spinner animation="border" size="sm" /> : 'Save'}
						</Button>
					</div>
				</React.Fragment>
			)}
		</main>
	);
}

export default SalesProfileView;
